import { render, staticRenderFns } from "./GlobalPromoTrigger.vue?vue&type=template&id=0bf9862c"
import script from "./GlobalPromoTrigger.vue?vue&type=script&lang=js"
export * from "./GlobalPromoTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports